const whole = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});
const cents = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

// formatMoney turns integer cents into a display figure. Whole dollars drop
// the decimals ($1,250); anything else keeps them ($123.45).
export function formatMoney(amountCents: number): string {
  if (amountCents % 100 === 0) return whole.format(amountCents / 100);
  return cents.format(amountCents / 100);
}

// formatCountdown renders the time left as its two largest units, or null
// once the moment has passed, so callers never show a negative countdown.
export function formatCountdown(msLeft: number): string | null {
  if (msLeft <= 0) return null;
  const s = Math.floor(msLeft / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (d > 0) return `${d}d ${h}h`;
  if (h > 0) return `${h}h ${m}m`;
  return `${m}m ${sec}s`;
}

// formatBps renders basis points as a percent with no trailing zeros:
// 1500 -> "15%", 1250 -> "12.5%". Display only; it never feeds a payout.
export function formatBps(bps: number): string {
  return `${Number((bps / 100).toFixed(2))}%`;
}
